var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value"},[(_vm.different)?_c('span',{staticClass:"old"},[_vm._v(_vm._s(_vm.oldValue))]):_vm._e(),_c('span',{staticClass:"new",class:{ different: _vm.different }},[_vm._v(_vm._s(_vm.newValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }